import RecordAction from '../RecordAction';
import ApplicationModel from 'components/framework/ApplicationModel';
import { RecordPlacementEnum } from 'components/framework/Enums';
import type { Feature, Requirement } from 'components/framework/models';

const { Project, BookmarksWorkflowBoard } = ApplicationModel.models;
type RecordType = Feature | Requirement;

export class MoveToWorkflowBoardAction extends RecordAction<RecordType> {
  recordTypes = ['Feature', 'Requirement'];

  get title() {
    return 'Move to workflow board';
  }

  showForRecord(record: ApplicationModel): record is RecordType {
    if (!super.showForRecord(record)) {
      return false;
    }

    if (
      'recordPosition' in record &&
      typeof record.recordPosition === 'function'
    ) {
      const hasWorkflowBoardPosition = record.recordPosition(
        BookmarksWorkflowBoard.bookmarkName
      );
      // Record is already on the board
      if (hasWorkflowBoardPosition) {
        return false;
      }
    }

    const teamId = record.team?.id;

    return !!(teamId && teamId === window.currentProject?.id);
  }

  showForSelectedRecords() {
    if (
      window.currentProject?.iterationsEnabled ||
      !window.currentProject?.backlogManagementEnabled ||
      !window.currentProject?.isTeam
    ) {
      return false;
    }
    return super.showForSelectedRecords();
  }

  async runForRecords(records: RecordType[]) {
    if (!window.currentProject?.id) {
      return;
    }

    const project = await Project.select('id')
      .merge({ workflowBoardBookmark: ['id'] })
      .find(window.currentProject?.id);

    await Promise.all(
      records.map(record =>
        record.setRecordPosition({
          bookmarkType: BookmarksWorkflowBoard.bookmarkName,
          bookmarkId: project.workflowBoardBookmark?.id!,
          secondaryScopeId: record.teamWorkflowStatus?.id,
          // @ts-ignore - Not sure what the issue is here
          placement: RecordPlacementEnum.BOTTOM,
          options: { args: { __reactivelyUpdate: true } },
        })
      )
    );
  }
}
